import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
    persistReducer, persistStore, FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import TagSlice from "./TagSlice";
import DocumentSlice from "./DocumentSlice"
import IssuerSlice from "./IssuerSlice";
import UserSlice from './UserSlice'
import LogSlice from "./LogSlice";
import CartSlice from "./CartSlice"

import Config from "./configSlice"
import { APP_NAME } from "../Strings";

import { encryptTransform } from "redux-persist-transform-encrypt";

const SECRET_KEY = APP_NAME;
const encryptor = encryptTransform({
  secretKey: SECRET_KEY,
  onError: function (error) {
    console.error("Encryption error:", error);
  },
});


const persistConfig = {
    key: 'root',
    storage,
    whiteList:['User'],
    transforms: [encryptor],
}

const rootReducer = combineReducers({
    Tags: TagSlice,
    Documents: DocumentSlice,
    Issuers: IssuerSlice,
    User: UserSlice,
    logs: LogSlice,
    cart: CartSlice,
    config:Config
});

const persistedReducer = persistReducer(persistConfig, rootReducer);


export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)